import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import EwsSweepRule from 'owa-service/lib/contract/EwsSweepRule';
import SetSweepRuleOperation from 'owa-service/lib/contract/SetSweepRuleOperation';

export default {
    numSweepRules: {
        datapoint: {
            name: 'TnS_NumSweepRules',
            customData: (sweepRuleCollectionLength: number) => [sweepRuleCollectionLength],
        },
    },
    setSweepRule: {
        datapoint: {
            name: 'TnS_SetSweepRule',
            customData: (sweepRuleId: string, sweepOperation: SetSweepRuleOperation) => [
                sweepRuleId,
                sweepOperation,
            ],
        },
    },
    sweepRuleInfo: {
        datapoint: {
            name: 'TnS_SweepRuleInformation',
            customData: (sweepRule: EwsSweepRule) => [
                folderIdToName(sweepRule.SweepConditions[0].SourceFolderId),
                folderIdToName(sweepRule.SweepActions[0].DestinationFolderId),
                sweepRule.SweepActions[0].CleanUpType,
                sweepRule.SweepActions[0].KeepCount,
            ],
        },
    },
};
